import { LINK_OF_ALL_PAGES } from "const/common";
import Image from "next/image";
import PrimaryButton from "../common/PrimaryButton";
const Office = "/assets/careers/office-1.webp";
const SecondOffice = "/assets/careers/office-2.webp";
const Together = "/assets/careers/together.webp";
const ExternalView = "/assets/careers/external-view.webp";
const Meeting = "/assets/careers/meeting.webp";
const Discuss = "/assets/careers/discuss.webp";

const Animation = () => {
  return (
    <>
      <div className="py-16 flex overflow-hidden select-none bg-primary-black">
        <div className="shrink-0 flex center gap-4 ml-4 transition-[left] duration-500 ease-in delay-0 animate-scroll will-change-[left]">
          <div className="flex flex-col gap-4">
            <div className="fs-0">
              <Image
                alt="office"
                src={Office}
                width={558}
                height={410}
                loading="eager"
              />
            </div>
            <div className="fs-0">
              <Image
                alt="office"
                src={SecondOffice}
                width={558}
                height={221}
                loading="eager"
              />
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <div className="fs-0">
              <Image
                alt="office"
                src={Together}
                width={226}
                height={174}
                loading="eager"
              />
            </div>
            <div className="fs-0">
              <Image
                alt="office"
                src={ExternalView}
                width={224}
                height={455}
                loading="eager"
              />
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <div className="fs-0">
              <Image
                alt="office"
                src={Meeting}
                width={558}
                height={410}
                loading="eager"
              />
            </div>
            <div className="fs-0">
              <Image
                alt="office"
                src={Discuss}
                width={558}
                height={221}
                loading="eager"
              />
            </div>
          </div>
        </div>
        <div
          aria-hidden="true"
          className="shrink-0 flex center gap-4 ml-4 transition-[left] duration-500 ease-in delay-0 animate-scroll will-change-[left]"
        >
          <div className="flex flex-col gap-4">
            <div className="fs-0">
              <Image
                alt="office"
                src={Office}
                width={558}
                height={410}
                loading="eager"
              />
            </div>
            <div className="fs-0">
              <Image
                alt="office"
                src={SecondOffice}
                width={558}
                height={221}
                loading="eager"
              />
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <div className="fs-0">
              <Image
                alt="office"
                src={Together}
                width={226}
                height={174}
                loading="eager"
              />
            </div>
            <div className="fs-0">
              <Image
                alt="office"
                src={ExternalView}
                width={224}
                height={455}
                loading="eager"
              />
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <div className="fs-0">
              <Image
                alt="office"
                src={Meeting}
                width={558}
                height={410}
                loading="eager"
              />
            </div>
            <div className="fs-0">
              <Image
                alt="office"
                src={Discuss}
                width={558}
                height={221}
                loading="eager"
              />
            </div>
          </div>
        </div>
        <div
          aria-hidden="true"
          className="shrink-0 flex center gap-4 ml-4 transition-[left] duration-500 ease-in delay-0 animate-scroll will-change-[left]"
        >
          <div className="flex flex-col gap-4">
            <div className="fs-0">
              <Image
                alt="office"
                src={Office}
                width={558}
                height={410}
                loading="eager"
              />
            </div>
            <div className="fs-0">
              <Image
                alt="office"
                src={SecondOffice}
                width={558}
                height={221}
                loading="eager"
              />
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <div className="fs-0">
              <Image
                alt="office"
                src={Together}
                width={226}
                height={174}
                loading="eager"
              />
            </div>
            <div className="fs-0">
              <Image
                alt="office"
                src={ExternalView}
                width={224}
                height={455}
                loading="eager"
              />
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <div className="fs-0">
              <Image
                alt="office"
                src={Meeting}
                width={558}
                height={410}
                loading="eager"
              />
            </div>
            <div className="fs-0">
              <Image
                alt="office"
                src={Discuss}
                width={558}
                height={221}
                loading="eager"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center bg-primary-black md:pt-4 md:pb-8">
        <PrimaryButton
          link={LINK_OF_ALL_PAGES.mainPages.contactUs}
          val="Join our Team"
        />
      </div>
    </>
  );
};

export default Animation;
